import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    static targets = ["tagSelect"]

    connect() {
        console.log("✅ tags_controller connected")
    }

    update(event) {
        const functionId = event.target.value

        if (!functionId) {
            this.clearOptions()
            return
        }

        fetch(`/functions/${functionId}/tags`, {
            headers: { Accept: "application/json" }
        })
            .then(response => {
                if (!response.ok) throw new Error("Netzwerkfehler beim Laden der Tags")
                return response.json()
            })
            .then(data => {
                this.populateTags(data)
            })
            .catch(error => {
                console.error(error)
                this.clearOptions()
            })
    }

    clearOptions() {
        this.tagSelectTarget.innerHTML = ""
        const promptOption = document.createElement("option")
        promptOption.value = ""
        promptOption.textContent = this.tagSelectTarget.dataset.prompt || "--- bitte wählen ---"
        this.tagSelectTarget.appendChild(promptOption)
    }

    populateTags(tags) {
        this.clearOptions()
        tags.forEach(tag => {
            const option = document.createElement("option")
            option.value = tag.id
            option.textContent = tag.description
            this.tagSelectTarget.appendChild(option)
        })
    }
}
